// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1NNl-","inputWrap":"styles_inputWrap__2fT67","input":"styles_input__UEi9B"};